import { JourneyEvent } from "./journeyEventBuilder";

/**
 * Bounded, in-memory ring buffer of the most recent JourneyEvents, used to
 * attach "what led up to it" context to errors.
 *
 * In-memory only: never persisted to localStorage/redux-persist, so it
 * cannot leak into browser storage or survive a hard refresh.
 */
export interface JourneyEventBuffer {
  push(event: JourneyEvent | null | undefined): void;
  getAll(): JourneyEvent[];
  clear(): void;
}

export const createJourneyEventBuffer = (capacity = 20): JourneyEventBuffer => {
  let events: JourneyEvent[] = [];

  return {
    push(event) {
      if (!event) {
        return;
      }
      events = [...events, event];
      if (events.length > capacity) {
        events = events.slice(events.length - capacity);
      }
    },
    getAll() {
      return [...events];
    },
    clear() {
      events = [];
    },
  };
};
